import { z } from "zod";

export const bulkRemindInvitationsSchema = z.object({
	note: z.string().max(500).optional(),
});

export type BulkRemindInvitationsPayload = z.infer<typeof bulkRemindInvitationsSchema>;
